import React, { Fragment, Component } from 'react'
import store from '../store'
class Company extends Component{
  constructor(props){
    super(props);
    this.state = store.getState();
    this.handleStoreChange = this.handleStoreChange.bind(this);
    store.subscribe(this.handleStoreChange);
  }
  render(){
    return(
      <Fragment>
        <div className='m1top center960'>
          <img className='m1img' src={this.state.company.ad} alt='pictures' />
          <div className='m1desc'>
            <div className='m1topic'>{this.state.company.topic}</div>
            {
              this.state.company.context.map((item,index)=>{
                return(
                  <Fragment>
                    <div className='m1text'>{item.desc}</div>
                    <img className='m1img' src={item.imgurl} alt='pictures' />
                  </Fragment>
                )
              })
            }
            
          </div>
        </div>
      </Fragment>
    );
  }
  handleStoreChange() {
    this.setState(store.getState());
  }
}

export default Company;